import { useState, useEffect, Fragment } from 'react';
// import { Deck, Slide } from 'spectacle';
import { ThemeProvider } from 'styled-components';
import { Helmet } from 'react-helmet';
import theme from './theme';
import { mergeTheme, oneTheme } from './deckTheme';
// import topBackground from './imgs/02-top_vocation_start_page.png';
// import backBackground from './imgs/02-back_m.png';
import innerPresentationBack from './imgs/02-inner_presentation_start.png';
// import vocationHeaderLogo from './imgs/vocation_start_heading.png';
import vocationHeaderLogo from './imgs/vocation_start_horizontal.svg';

import { ResetCSS, GlobalStyle, PageWrapper, PageNumber } from './styles';
// pages
// import TopPage from './Pages/Top';
// import ClosePage from './Pages/Close';
import PresentationPage from './Pages/Presentation';
import InfoDataPage from './Pages/InfoData';
import CreenciasHabilidades from './Pages/CreenciasHabilidades';
import CreenciasHabilidadesSecond from './Pages/CreenciasHabilidadesSecond';
import IncertidumbreTransicion from './Pages/IncertidumbreTransicion';
import IncertidumbreTransicionSecond from './Pages/IncertidumbreTransicionSecond';
import RecursosTransicion from './Pages/RecursosTransicion';
import RecursosTransicionSecond from './Pages/RecursosTransicionSecond';
import RecursosTransicionThird from './Pages/RecursosTransicionThird';
import ClosingPage from './Pages/ClosingPage';
// import CoverPageAlt from './Pages/CoverPageAlt';
import CoverPage from './Pages/CoverPage';
import BackCover from './Pages/BackCover';

// import EnfoqueGraphPage from './Pages/EnfoqueGraph';
import MotivationScalesDescriptionPage from './Pages/MotivationScalesDescription';
import MotivationScalesDescriptionCont from './Pages/MotivationScalesDescriptionCont';
import StrategyScalesDescriptionPage from './Pages/StrategyScalesDescription';
import StrategyScalesDescriptionCont from './Pages/StrategyScalesDescriptionCont';

const Deck = props => {
  console.log({ props });
  const style = {
    // position: 'relative',
    // height: `${props.theme.size.height}px`,
    // width: `${props.theme.size.width}px`,
    backgroundColor: props.backgroundColor || '#FFFFFF',
    page: 'single' // css page definition
  };
  return <div style={style}>{props.children}</div>;
};

const Slide = props => {
  const style = {
    position: 'relative',
    display: 'block',
    height: `1123px`,
    width: `794px`,
    marginTop: '-2px',
    backgroundColor: props.backgroundColor || 'transparent',
    overflow: 'hidden'
  };
  return (
    <div className='page' id='single' style={style}>
      {props.children}
    </div>
  );
};

// Slider Deck theme
const deckTheme = mergeTheme(oneTheme);
console.log({ deckTheme });

// https://github.com/FormidableLabs/spectacle/blob/master/docs/content/advanced-concepts.md#query-parameters
// add to url
// &exportMode=true
export const SlidePage = ({ number, children, background, header = true }) => {
  const isEven = number % 2 === 0;
  // console.log({ number, isEven });
  return (
    <PageWrapper backgroundImage={background}>
      {header && (
        <div
          style={{
            position: 'absolute',
            top: 85,
            left: 0,
            right: 0,
            marginLeft: 92,
            marginRight: 75
          }}
        >
          <img
            src={vocationHeaderLogo}
            alt='vocation start header'
            style={{ height: 34 }}
          />
          <div
            style={{ height: 4, background: '#f0c045', width: '100%' }}
          ></div>
        </div>
      )}
      {children}
      {number && <PageNumber even={isEven}>{number}</PageNumber>}
    </PageWrapper>
  );
};

// /r/88530e6c-cba2-482d-a97d-4575b79dfb88
// /r/88530e6c-cba2-482d-a97d-4575b79dfb88?exportMode=true&slide=0&slideElement=-1

// http://localhost:3000/r/27389a2c-3281-46cb-9345-764c6a1620dd?slideIndex=0&stepIndex=0

const VocationStart = ({ campaign, response, data }) => {
  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(false);
  const [user, setUser] = useState(null);
  // console.log({ props });

  useEffect(() => {
    // console.log({ params });
    const parseUser = async () => {
      const userData = data;
      // console.log({ userData });
      // // –––– for local  dummy
      // const userData = vocationStartDummy;
      // // –––––––––––––––––––––
      // const fields = Object.keys(userData);
      // console.log({ fields });

      // console.log({ sortedDisp });
      const baseInfo = {
        RUT: userData.rut,
        name: '',
        lastname: '',
        grade: '',
        school: campaign.organization || campaign.title
      };
      const school = userData.school || baseInfo.school;
      const parsedUser = {
        ...baseInfo,
        ...userData,
        school,
        createdAt: response.createdAt,
        updatedAt: response.updatedAt,
        responseId: response.id,
        responseAccessKey: response.accessKey
      };
      setUser(parsedUser);
      setLoading(false);
    };
    parseUser();
  }, [data, campaign, response]);

  // console.log({ user });
  if (loading) {
    return <div>loading...</div>;
  }
  const userSchool = user.school ? `_${user.school.split(' ').join('_')}` : '';
  const userGrade = user.grade ? `${user.grade.split(' ').join('_')}_` : '';

  // const campaignLogo =
  //   'https://www.edumetrics.cl/static/imgs/logos/LogoBradford.png';

  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <Helmet>
          <title>{`${userGrade}${user.RUT}${userSchool}_VocationStart`}</title>
        </Helmet>
        <ResetCSS />
        <GlobalStyle />
        <Deck theme={deckTheme} backgroundColor='#fff'>
          {/* <Slide backgroundColor='#fff'>
            <TopPage user={user} background={topBackground} header={false} />
          </Slide> */}

          {/* <Slide backgroundColor='#f0c045'>
            <CoverPage user={user} header={false} />
          </Slide> */}

          {/* <Slide backgroundColor='#f0c045'>
            <CoverPage
              user={user}
              header={false}
              campaign={{ ...campaign, logo: campaignLogo }}
            />
          </Slide> */}

          <Slide backgroundColor='#f0c045'>
            <CoverPage user={user} header={false} campaign={campaign} />
          </Slide>

          {/** BLANK PAGE */}
          <Slide backgroundColor='#fff'>
            <SlidePage header={false}></SlidePage>
          </Slide>

          <Slide backgroundColor='#fff'>
            <PresentationPage
              user={user}
              number={1}
              background={innerPresentationBack}
            />
          </Slide>

          <Slide backgroundColor='#fff'>
            <InfoDataPage user={user} number={2} />
          </Slide>

          <Slide backgroundColor='#fff'>
            <MotivationScalesDescriptionPage user={user} number={3} />
          </Slide>
          <Slide backgroundColor='#fff'>
            <MotivationScalesDescriptionCont user={user} number={4} />
          </Slide>

          <Slide backgroundColor='#fff'>
            <StrategyScalesDescriptionPage user={user} number={5} />
          </Slide>
          <Slide backgroundColor='#fff'>
            <StrategyScalesDescriptionCont user={user} number={6} />
          </Slide>

          <Slide backgroundColor='#fff'>
            <CreenciasHabilidades user={user} number={7} />
          </Slide>

          <Slide backgroundColor='#fff'>
            <CreenciasHabilidadesSecond user={user} number={8} />
          </Slide>

          <Slide backgroundColor='#fff'>
            <IncertidumbreTransicion user={user} number={9} />
          </Slide>

          <Slide backgroundColor='#fff'>
            <IncertidumbreTransicionSecond user={user} number={10} />
          </Slide>

          <Slide backgroundColor='#fff'>
            <RecursosTransicion user={user} number={11} />
          </Slide>

          <Slide backgroundColor='#fff'>
            <RecursosTransicionSecond user={user} number={12} />
          </Slide>

          <Slide backgroundColor='#fff'>
            <RecursosTransicionThird user={user} number={13} />
          </Slide>

          <Slide backgroundColor='#fff'>
            <ClosingPage number={14} user={user} />
          </Slide>

          {/* <Slide backgroundColor='#fff'>
            <ClosePage background={backBackground} header={false} />
          </Slide> */}

          <Slide backgroundColor='#fff'>
            <BackCover backgroundColor='#fff' header={false} />
          </Slide>
        </Deck>
      </Fragment>
    </ThemeProvider>
  );
};

export default VocationStart;
